/* eslint-disable no-param-reassign */
import qs from 'qs';
import Link from 'next/link';
import { withRouter } from 'next/router';

const pages = [[/^\/[a-z-]+\//, '/[type]/[[...facetId]]']];

export const defaultFilter = () => [
  'search-term',
  'sortBy',
  'page',
  'facet',
  'cardSize',
  'listHead',
  'lolcode',
  'plpView',
];

export const sortFilter = () => [
  'search-term',
  'sortBy',
  'cardSize',
  'listHead',
  'lolcode',
  'plpView',
];

export const facetsFilter = () =>
  defaultFilter().concat(['price', 'priceBands']);

export const plpViewTypeFilter = () => facetsFilter().concat(['chunk']);

export const plpCardSizeFilter = () => facetsFilter().concat(['chunk']);

export const foundItFilter = () => sortFilter().concat(['fi']);

export const resolvePage = (href) => {
  const page = pages.find(([regex]) => regex.test(href));
  if (!page) {
    return href;
  }
  return page[1];
};

export const getQueryParams = (query, filter) =>
  Object.keys(query).reduce((filtered, key) => {
    const value = query[key];

    if (filter.includes(key)) {
      filtered[key] = value;
    }

    if (key === 'facetId' && value === '') {
      filtered[key] = value;

      if (value === '') {
        filtered[key] = null;
      }
    }

    if (['page', 'facet'].includes(key) && !value) {
      delete filtered[key];
    }

    if (key === 'page' && Number(value) === 1) {
      delete filtered[key];
    }

    return filtered;
  }, {});

export const getQueryString = (query, queryOpts = {}) => {
  const stringifyOpts = { encode: false, skipNulls: true, ...queryOpts };
  return qs.stringify(query, stringifyOpts);
};

export const StatefulLink = ({
  query,
  facetId,
  facetType,
  children,
  router,
  queryOpts,
  scroll,
  ...DOMProps
}) => {
  const routerQuery = { ...router.query };
  const { type } = routerQuery;

  const pageType = facetType || type;
  let facetPath = facetId;

  if (typeof facetPath !== 'string') {
    facetPath = routerQuery.facetId ? routerQuery.facetId.join('/') : '';
  }
  const urlPrefixRegex = new RegExp(`^/(brand|browse|search|s)/`);
  facetPath = facetPath.replace(urlPrefixRegex, '/');

  const filter = queryOpts?.filter || defaultFilter();

  const stringifyOpts = { encode: false, skipNulls: true, ...queryOpts };

  const queryParams = {
    ...routerQuery,
    ...query,
    facetId: facetPath,
  };

  const filteredQueryParams = getQueryParams(queryParams, filter);

  const queryString = getQueryString(filteredQueryParams, stringifyOpts);

  let as = `/${pageType}/${facetPath}?${queryString}`.replace(/\/{2,}/g, '/'); // Replaces // with /
  const pathname = resolvePage(as);
  // remove trailing ? if one exists
  if (as[as.length - 1] === '?') {
    as = as.slice(0, as.length - 1);
  }

  return (
    <Link
      legacyBehavior={true}
      href={{ pathname, query: filteredQueryParams }}
      as={as.replace(/(?=\/(\?|$))\//, '')}
      scroll={scroll}
    >
      <a {...DOMProps}>{children}</a>
    </Link>
  );
};

export default withRouter(StatefulLink);
